export default __webpack_public_path__ + "static/media/img9.23da85b9.png";